import React from 'react'
import AutoTooltip, { AutoTooltipContent } from '../AutoTooltip'
import BodyText from 'components/Luxkit/Typography/BodyText'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { INTL_DMY_CASUAL_FORMAT } from 'constants/dateFormats'

const CONTENT_WIDTH = 204

interface Props extends React.PropsWithChildren {
  dates?: {
    bookBy: moment.Moment,
    travelUntil: moment.Moment,
  }
  customText?: string;
  onOpen?: () => void;
}

export default function GiftTooltip(props: Props) {
  const { children, dates, customText, onOpen } = props

  const { t } = useTranslation('offerPage')

  let msg = ''
  if (customText) {
    msg = customText
  } else if (dates) {
    msg = t('giftShortExplanation', { ns: 'offerPage', bookBy: dates.bookBy, travelUntil: dates.travelUntil, ...INTL_DMY_CASUAL_FORMAT })
  }

  return <AutoTooltip onOpen={onOpen}>
    {children}
    <AutoTooltipContent width={CONTENT_WIDTH} position="above" type="dark">
      <BodyText variant="small">
        {msg}
      </BodyText>
    </AutoTooltipContent>
  </AutoTooltip>
}
